import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container section-padding lg:grid lg:grid-cols-12"
}
const _hoisted_2 = { class: "flex flex-col lg:col-start-3 lg:col-end-11" }
const _hoisted_3 = { class: "pb-6 text-xl font-bold lg:pb-11" }
const _hoisted_4 = ["target", "href"]
const _hoisted_5 = { class: "lg:mr-6" }
const _hoisted_6 = { class: "break-words font-bold lg:text-lg" }
const _hoisted_7 = {
  key: 0,
  class: "mt-1.5 text-gray-400"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "mx-1.5"
}
const _hoisted_10 = {
  key: 2,
  class: "mx-1.5"
}
const _hoisted_11 = {
  key: 3,
  class: "mx-1.5"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "mx-1.5" }, "|", -1)
const _hoisted_13 = { class: "hidden border border-black p-3 group-hover:bg-black group-hover:text-white lg:block" }
const _hoisted_14 = { class: "flex justify-end pt-7 lg:pt-10" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "absolute right-9 top-1/2 -mt-0.5 inline-block h-3 w-3 -translate-y-1/2 transform" }
const _hoisted_17 = {
  ref: "othercareers",
  class: "w-fit text-gray-400 transition-transform duration-500"
}
const _hoisted_18 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_biz_icon = _resolveComponent("biz-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'bg-black': _ctx.careers.length == 0 })
  }, [
    (_ctx.careers.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.careers, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "group border-b border-black/30 py-7 first:pt-0 lg:py-10 first:lg:pt-0"
                }, [
                  _createElementVNode("a", {
                    target: item.detailsUrlTarget,
                    href: item.detailsUrl,
                    class: "lg:flex lg:items-center lg:justify-between"
                  }, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1),
                      (item.city || item.country || item.company || item.jobType)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createTextVNode(_toDisplayString(item.city) + " ", 1),
                            (item.city && item.country)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, ", "))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(item.country) + " ", 1),
                            (
                                            (item.company || item.jobType || item.jobCategory) &&
                                            (item.city || item.country)
                                        )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "|"))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(item.company) + " ", 1),
                            (item.company && (item.jobType || item.jobCategory))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_10, " | "))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(item.jobType) + " ", 1),
                            (item.jobType && item.jobCategory)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "|"))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(item.jobCategory) + " ", 1),
                            _hoisted_12,
                            _createTextVNode(" " + _toDisplayString(item.jobId), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_biz_icon, {
                        class: "h-3.5 w-3.5 shrink-0 fill-current",
                        name: "chevron-right"
                      })
                    ])
                  ], 8, _hoisted_4)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("a", {
                href: _ctx.parentUrl + _ctx.parentHash,
                class: "button-secondary group relative px-9 py-3 font-bold hover:pr-16"
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.buttonLabel), 1),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_biz_icon, {
                    class: "ml-2 h-4 w-4 shrink-0 fill-current opacity-0 transition-opacity group-hover:animate-fade-r",
                    name: "chevron-right"
                  })
                ])
              ], 8, _hoisted_15)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("a", {
        href: _ctx.parentUrl,
        class: "z-40 ml-20 flex cursor-pointer items-center bg-gray-200 px-10 py-8 hover:bg-gray-100"
      }, [
        _createVNode(_component_biz_icon, {
          class: "mr-2 h-4 w-4 shrink-0 rotate-180 fill-current",
          name: "chevron-right"
        }),
        _createElementVNode("span", null, _toDisplayString(_ctx.seeOverview), 1)
      ], 8, _hoisted_18)
    ], 512)
  ], 2))
}